export default {
  title: 'Sorry!',
  message: 'My Client Space is unavailable at the moment. We apologize for any inconvenience this may cause you.',
  unavailableUntil: 'Our systems will be available again on ',
  homeButton: 'Go to home page',
};
